// extracted by mini-css-extract-plugin
export default {"bar":"Kb1XiX","shimmer":"UZztTJ"};